import React from 'react';
import { Cliente, Contenuto } from '../types';
import { etichettaDestinazione } from '../utils/accountDestinazione';

// Badge "per quale profilo" sulle card dei contenuti. Non compare per i
// clienti con un profilo solo né quando la scelta non è stata fatta.
const AccountDestinazioneBadge: React.FC<{
  contenuto: Pick<Contenuto, 'accountDestinazione'>;
  cliente?: Pick<Cliente, 'accountPubblicazione'> | null;
  className?: string;
}> = ({ contenuto, cliente, className = '' }) => {
  const etichetta = etichettaDestinazione(contenuto, cliente);
  if (!etichetta) return null;
  return (
    <span
      title="Profilo su cui va pubblicato"
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border border-[#0c0c0c] bg-[#fdf751] text-[#0c0c0c] whitespace-nowrap ${className}`}
    >
      {etichetta}
    </span>
  );
};

export default AccountDestinazioneBadge;
